// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3-15l","row":"Node_row__-_36c","label":"Node_label__28gIa","footer":"Node_footer__2kBZc"};